import { colors } from "colors"
import { Platform, StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  errorText: {
      color: colors.errorText,
      fontFamily: typography.primary.normal,
      marginBottom: 8,
  },
  titleContainer: {
    backgroundColor: colors.white,
    left: 15,
    opacity: 1,
    position: "absolute",
    top: 2,
    zIndex: 99,
  },
  title: {
    fontFamily: typography.primary.normal,
    fontSize: 12,
    paddingHorizontal: 4,
  },
})
